import { Tag } from 'antd';
import { Optional } from '../../Shared';
import Title from 'antd/lib/typography/Title';
import { WarningOutlined } from '@ant-design/icons';
import { shiftBackgroundColours } from '../../../theme';

const ShiftDisplayHeading: React.FC<{
  readonly role: string;
  readonly employee: string | undefined;
  readonly startTime: string;
  readonly isVacant: boolean;
}> = ({ role, employee, startTime, isVacant }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <Title level={5}>{`[${role}]${
      employee === undefined ? '' : ` ${employee}`
    } on ${startTime}`}</Title>

    <Optional show={isVacant}>
      <Tag
        icon={<WarningOutlined />}
        color={shiftBackgroundColours.vacantDay}
        style={{ color: '#000000', marginBottom: '10px' }}
      >
        Vacant
      </Tag>
    </Optional>
  </div>
);

export default ShiftDisplayHeading;
